// file: Loader.component.tsx
import {LoadingOverlay} from '@mantine/core';
import React from 'react';

// Loader component
export class Loader extends React.Component {
  render(): React.ReactNode {
    return (
      <LoadingOverlay
        loaderProps={{size: 'lg', color: 'pink', variant: 'bars'}}
        overlayOpacity={0.3}
        overlayColor="#c5c5c5"
        visible
      />
    );
  }
}
